import { ArrowLeft, FileText } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import Table from "../components/reports/list_reports/Table";
import Filters from "../components/filters/Filters";

const PastReports = () => {
  const navigate = useNavigate();
  return (
    <section className="flex flex-col space-y-10">
      {/* Header */}
      <div className="bg-white rounded-lg shadow-sm p-6 border">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <FileText className="w-6 h-6 text-blue-600" />
            <h1 className="text-2xl font-bold text-gray-900">
              Past Report Details
            </h1>
          </div>

          <button
            onClick={() => navigate("/dashboard")}
            className="flex items-center gap-2 px-4 py-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Current Reports
          </button>
        </div>
      </div>

      <section>
        <Filters />
      </section>

      <section>
        <Table />
      </section>
    </section>
  );
};

export default PastReports;
